import { ISelectedCloningSession } from "@gtmhub/sessions/controllers/clone-sessions";

export enum JobStatus {
  Pending = "pending",
  InProgress = "in_progress",
  Done = "done",
  ToBeReverted = "to_be_reverted",
  Reverting = "reverting",
  Reverted = "reverted",
}

export enum ResourceType {
  Session = "session",
  KeyResult = "kr",
  Objective = "okr",
}

type ClonedIds = Record<string, string>;

interface ResourceRequest {
  type: ResourceType;
  resourceId: string;
  targetType: ResourceType;
  targetResourceId: string;
}

export interface CloneResourceRequest extends ResourceRequest {
  targetSessionId?: string;
  resetProgress?: boolean;
  cloneChildren?: boolean;
  cloneTasks?: boolean;
  cloneTasksStatus?: boolean;
  sendNotifications?: boolean;
  keepUpdatesInSync?: boolean;
  keepCrossSessionRelationships?: boolean;
  duplicateInsights?: boolean;
}

export interface MoveResourceRequest extends ResourceRequest {
  moveChildren?: boolean;
  targetSessionId: string;
}

export interface JobId {
  id: string;
}

export interface IMoveJob extends JobId {
  status: JobStatus;
  movedIds: ClonedIds;
  rootMovedId: string;
  resourceType: ResourceType;
}

export interface ICloneJob extends JobId {
  status: JobStatus;
  clonedIds: ClonedIds;
  rootClonedId: string;
  resourceType: ResourceType;
}

export interface CloneRequest {
  source: string;
  target: ISelectedCloningSession;
}

export interface NotificationInfo {
  targetSessionName?: string;
  targetGoalName?: string;
}
